<template>
  <validation-provider
    :disabled="!validatable"
    :name="fieldName || label"
    :rules="validatable ? rules : ''"
    :vid="vid"
    v-slot="validationContext"
    slim
  >
    <b-form-group
      v-bind="$attrs"
      :label-cols-sm="noLabel ? undefined : labelColsSm"
      :state="getValidationState(validatable, validationContext)"
      :class="controlClass"
      :label-class="labelClass"
    >
      <template slot="label">
        <div>
          {{ noLabel ? undefined : fieldLabel }}
          <base-help-icon :help-description="helpDescription" />
        </div>
      </template>
      <slot v-bind:state="getValidationState(validatable, validationContext)">
        <b-textarea
          v-if="textarea"
          :value="value"
          :state="getValidationState(validatable, validationContext)"
          @input="emitValue"
          :rows="rows"
          :placeholder="placeholder"
        />
        <b-form-input
          v-else
          :value="value"
          :state="getValidationState(validatable, validationContext)"
          @input="emitValue"
          :type="type"
          :placeholder="placeholder"
          :autocomplete="autocompleteOff ? 'new-password' : ''"
        />
      </slot>
      <b-form-invalid-feedback
        v-if="validatable"
        :state="getValidationState(validatable, validationContext)"
      >
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { BaseHelpIcon } from "./";
import { baseValidatableMixin } from "@foys-tech/foys-utils";
export default {
  mixins: [baseValidatableMixin],
  components: { BaseHelpIcon },
  props: {
    /**
     * Input field html type: text, number, ...
     */
    type: {
      type: String,
      default: "text",
    },
    /**
     * Indicated if textarea should be used
     */
    textarea: {
      type: Boolean,
      default: false,
    },
    /**
     * Number of textarea rows if textarea is enabled
     */
    rows: {
      type: Number,
      default: 3
    },
    /**
     * Disable autocomplete for password fields
     */
    autocompleteOff: {
      type: Boolean,
      default: false,
    },
  },
};
</script>